export default __webpack_public_path__ + "static/media/switch-circle-white.215f8ced.svg";